<template>
  <div id="stats">

   <div v-if="getUser()">
    <b-row>
      <b-col>
        <GChart
        type="PieChart"
        :data="locationsUser()"
        :options="pieChartOptions"
        />
      </b-col>
    </b-row>
    <br>
    <hr>
    <b-row>
      <b-col>
        <GChart
        type="ColumnChart"
        :data="shipmentsChartUser()"
        :options="columnChartOptions"
        />
      </b-col>
    </b-row>
    <br>
    <hr>
    <b-row>
      <b-col>
        <GChart
        type="ScatterChart"
        :data="goodChartUser()"
        :options="scatterChartOptions"
        />
      </b-col>
    </b-row>
  </div>

  <div v-else>
    <b-row>
      <b-col>
        <GChart
        type="PieChart"
        :data="locations()"
        :options="pieChartOptions"
        />
      </b-col>
    </b-row>
    <br>
    <hr>
    <b-row>
      <b-col>
        <GChart
        type="ColumnChart"
        :data="shipmentsChart()"
        :options="columnChartOptions"
        />
      </b-col>
    </b-row>
    <br>
    <hr>
    <b-row>
      <b-col>
        <GChart
        type="ScatterChart"
        :data="goodChart()"
        :options="scatterChartOptions"
        />
      </b-col>
    </b-row>
  </div>


</div>
</template>



<style>
#stats{
  padding: 50px 200px 200px 200px;
}
</style>

<script>
import { shipmentsRef } from '../firebase'
import { batchRef } from '../firebase'
import { butterflyRef } from '../firebase'
export default {
  name: 'stats',
  data () {
    return {
      shipments: [],
      butterflies: [],
      batches: [],
      pieChartOptions: {
        title: 'Distribution of origin of butterfly species',
        legend: {position: 'bottom'},
        'tooltip' : {
          trigger: 'none'
        }
      },
      columnChartOptions: {
        title: 'Butterfly pupue received by month',
        legend: {position: 'bottom'},
        'tooltip' : {
          trigger: 'none'
        }
      },
      scatterChartOptions: {
        title: 'Good emergences per batch vs number received',
        legend: {position: 'bottom'},
        'tooltip' : {
          trigger: 'none'
        }
      },
    }
  },
  firebase: {
    shipments: shipmentsRef,
    butterflies: butterflyRef,
    batches: batchRef
  },
  methods: {
    locations(){
      var na=0,sa=0,eu=0,as=0,af=0,au=0,an=0,un=0;
      for(let i = 0; i<this.butterflies.length; i++){
        if(this.butterflies[i].northAmerica=='accepted'){
          na++;
        }
        if(this.butterflies[i].southAmerica=='accepted'){
          sa++;
        }
        if(this.butterflies[i].europe=='accepted'){
          eu++;
        }
        if(this.butterflies[i].asia=='accepted'){
          as++;
        }
        if(this.butterflies[i].africa=='accepted'){
          af++;
        }
        if(this.butterflies[i].australia=='accepted'){
          au++;
        }
        if(this.butterflies[i].antartica=='accepted'){
          an++;
        }
        if(this.butterflies[i].unknown=='accepted'){
          un++;
        }
      }
      var locationArr = [
      ['Location', 'Numbers'],
      ['North America', na],
      ['South America', sa],
      ['Europe', eu],
      ['Asia', as],
      ['Africa', af],
      ['Australia', au],
      ['Antartica', an],
      ['Unknown', un],
      ];

      return locationArr;
    },
    shipmentsChart(){
      var jan=0, feb=0, mar=0, apr=0, may=0, jun=0, jul=0, aug=0, sep=0, oct=0, nov=0, dec=0;
      for(let i =0; i<this.shipments.length; i++){
        var date = new Date(this.shipments[i].arrivalDate);
        switch(date.getMonth()){
          case 0:
          jan+=parseInt(this.shipments[i].numberReceived);
          break;
          case 1:
          feb+=parseInt(this.shipments[i].numberReceived);
          break;
          case 2:
          mar+=parseInt(this.shipments[i].numberReceived);
          break;
          case 3:
          apr+=parseInt(this.shipments[i].numberReceived);
          break;
          case 4:
          may+=parseInt(this.shipments[i].numberReceived);
          break;
          case 5:
          jun+=parseInt(this.shipments[i].numberReceived);
          break;
          case 6:
          jul+=parseInt(this.shipments[i].numberReceived);
          break;
          case 7:
          aug+=parseInt(this.shipments[i].numberReceived);
          break;
          case 8:
          sep+=parseInt(this.shipments[i].numberReceived);
          break;
          case 9:
          oct+=parseInt(this.shipments[i].numberReceived);
          break;
          case 10:
          nov+=parseInt(this.shipments[i].numberReceived);
          break;
          case 11:
          dec+=parseInt(this.shipments[i].numberReceived);
          break;      
        }
      }

      var shipmentArr = [
      ['Month','Numbers Received'],
      ['Jan', jan],
      ['Feb', feb],
      ['Mar', mar],
      ['Apr', apr],
      ['May', may],
      ['Jun', jun],
      ['Jul', jul],
      ['Aug', aug],
      ['Sep', sep],
      ['Oct', oct],
      ['Nov', nov],
      ['Dec', dec],
      ];
      return shipmentArr;
    },
    goodChart(){
      var goodArr = [
      ['Received', 'Good'],
      [0, 0],
      ];

      var newArr = [
      ['Received', 'Good']
      ];
      for(let i =0; i<this.batches.length; i++){
        for(let j=0; j<this.shipments.length; j++){
          if(this.shipments[j]['.key']==this.batches[i].id){
            newArr.push([parseInt(this.shipments[j].numberReceived), parseInt(this.batches[i].good)]);
            goodArr = newArr;

          }
        }   
      }
      return goodArr;
    },
    locationsUser(){
      var na=0,sa=0,eu=0,as=0,af=0,au=0,an=0,un=0;
      var userButterflies = this.butterflies.filter(this.thisUser);
      for(let i = 0; i<userButterflies.length; i++){
        if(userButterflies[i].northAmerica=='accepted'){
          na++;
        }
        if(userButterflies[i].southAmerica=='accepted'){
          sa++;
        }
        if(userButterflies[i].europe=='accepted'){
          eu++;
        }
        if(userButterflies[i].asia=='accepted'){
          as++;
        }
        if(userButterflies[i].africa=='accepted'){
          af++;
        }
        if(userButterflies[i].australia=='accepted'){
          au++;
        }
        if(userButterflies[i].antartica=='accepted'){
          an++;
        }
        if(userButterflies[i].unknown=='accepted'){
          un++;
        }
      }
      var locationArr = [
      ['Location', 'Numbers'],
      ['North America', na],
      ['South America', sa],
      ['Europe', eu],
      ['Asia', as],
      ['Africa', af],
      ['Australia', au],
      ['Antartica', an],
      ['Unknown', un],
      ];

      return locationArr;
    },
    shipmentsChartUser(){
      var jan=0, feb=0, mar=0, apr=0, may=0, jun=0, jul=0, aug=0, sep=0, oct=0, nov=0, dec=0;
      var userShipments = this.shipments.filter(this.thisUser);
      for(let i =0; i<userShipments.length; i++){
        var date = new Date(userShipments[i].arrivalDate);
        switch(date.getMonth()){
          case 0:
          jan+=parseInt(userShipments[i].numberReceived);
          break;
          case 1:
          feb+=parseInt(userShipments[i].numberReceived);
          break;
          case 2:
          mar+=parseInt(userShipments[i].numberReceived);
          break;
          case 3:
          apr+=parseInt(userShipments[i].numberReceived);
          break;
          case 4:
          may+=parseInt(userShipments[i].numberReceived);
          break;
          case 5:
          jun+=parseInt(userShipments[i].numberReceived);
          break;
          case 6:
          jul+=parseInt(userShipments[i].numberReceived);
          break;
          case 7:
          aug+=parseInt(userShipments[i].numberReceived);
          break;
          case 8:
          sep+=parseInt(userShipments[i].numberReceived);
          break;
          case 9:
          oct+=parseInt(userShipments[i].numberReceived);
          break;
          case 10:
          nov+=parseInt(userShipments[i].numberReceived);
          break;
          case 11:
          dec+=parseInt(userShipments[i].numberReceived);
          break;      
        }
      }

      var shipmentArr = [
      ['Month','Numbers Received'],
      ['Jan', jan],
      ['Feb', feb],
      ['Mar', mar],
      ['Apr', apr],
      ['May', may],
      ['Jun', jun],
      ['Jul', jul],
      ['Aug', aug],
      ['Sep', sep],
      ['Oct', oct],
      ['Nov', nov],
      ['Dec', dec],
      ];
      return shipmentArr;
    },
    goodChartUser(){
      var goodArr = [
      ['Received', 'Good'],
      [0, 0],
      ];

      var newArr = [
      ['Received', 'Good']
      ];
      var userBatches = this.batches.filter(this.thisUser);
      var userShipments = this.shipments.filter(this.thisUser);
      for(let i =0; i<userBatches.length; i++){
        for(let j=0; j<userShipments.length; j++){
          if(userShipments[j]['.key']==userBatches[i].id){
            newArr.push([parseInt(userShipments[j].numberReceived), parseInt(userBatches[i].good)]);
            goodArr = newArr;

          }
        }   
      }
      return goodArr;
    },
    getUser(){
      return this.$parent.activeUser?this.$parent.activeUser.name:'';
    },
    thisUser(collection){
      return (collection.user == this.getUser() || this.getUser() == 'Reiman Gardens')?collection:null
    }
  }
}
</script>
